import 'twin.macro';
import React from 'react';
import { NarrowContainer, Size } from '@teetsh/app/src/components/Container';
import H1 from '@teetsh/app/src/components/Typography/Headings/H1';
import clsx from 'clsx';
import { ArrowLeftIcon as ArrowLeft } from '@heroicons/react/20/solid';
import { useNavigate } from 'react-router-dom';
import Button from '@teetsh/app/src/components/Buttons/Button';
import { useTranslation } from 'react-i18next';

export default function SimpleNarrowPage(props: {
  children?: React.ReactNode;
  className?: string;
  withBackButton?: boolean;
  width?: Size;
}) {
  const { children, width } = props;
  const navigate = useNavigate();
  const { t } = useTranslation(['common']);
  return (
    <NarrowContainer width={width} className={clsx(props.className)}>
      {props.withBackButton && (
        <Button icon={ArrowLeft} onClick={() => navigate(-1)} minimal>
          {t('common:buttons.back')}
        </Button>
      )}
      {children}
    </NarrowContainer>
  );
}

function SubTitle({ children }: { children?: React.ReactNode }) {
  return (
    <div tw="flex justify-center">
      <div tw="text-lg text-muted mb-8">{children}</div>
    </div>
  );
}

function Title({ children }: { children?: React.ReactNode }) {
  return (
    <div tw="flex justify-center">
      <H1 tw="mb-8">{children}</H1>
    </div>
  );
}

SimpleNarrowPage.Title = Title;
SimpleNarrowPage.SubTitle = SubTitle;
